var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H11V11C11 12.1046 10.1046 13 9 13H5C3.89543 13 3 12.1046 3 11V4Z",
    fill: "#D3E9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.49984H12.25H1.75Z",
    fill: "#D3E9E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 3.49984V3.03317C9.33333 2.37978 9.33333 2.05308 9.20617 1.80351C9.09432 1.58399 8.91584 1.40552 8.69632 1.29366C8.44676 1.1665 8.12006 1.1665 7.46667 1.1665H6.53333C5.87994 1.1665 5.55324 1.1665 5.30368 1.29366C5.08416 1.40552 4.90568 1.58399 4.79383 1.80351C4.66667 2.05308 4.66667 2.37978 4.66667 3.03317V3.49984M5.83333 6.70817V9.62484M8.16667 6.70817V9.62484M1.75 3.49984H12.25M11.0833 3.49984V10.0332C11.0833 11.0133 11.0833 11.5033 10.8926 11.8777C10.7248 12.2069 10.4571 12.4747 10.1278 12.6424C9.75347 12.8332 9.26342 12.8332 8.28333 12.8332H5.71667C4.73657 12.8332 4.24653 12.8332 3.87218 12.6424C3.5429 12.4747 3.27518 12.2069 3.10741 11.8777C2.91667 11.5033 2.91667 11.0133 2.91667 10.0332V3.49984",
    stroke: "#24352F",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.606fc006.svg";
export { ForwardRef as ReactComponent };